import React from "react";

function ChatSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.458"
        d="M3.854 5.01H7.5M3.854 7.562h5.833m-3.876 4.375h4.751c1.225 0 1.838 0 2.306-.238.411-.21.746-.545.956-.956.238-.468.238-1.08.238-2.306V4.5c0-1.225 0-1.838-.238-2.306a2.187 2.187 0 00-.956-.956C12.4 1 11.788 1 10.562 1H4.437C3.212 1 2.6 1 2.132 1.238c-.412.21-.746.545-.956.956C.938 2.662.938 3.274.938 4.5v9.14c0 .388 0 .583.08.682.068.087.173.138.284.138.128 0 .28-.122.583-.365l1.74-1.391c.355-.284.532-.426.73-.527a2.19 2.19 0 01.556-.195c.217-.045.445-.045.9-.045z"
      ></path>
    </svg>
  );
}

export default ChatSvg;
